import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';
import _ from 'underscore';

import {TextField} from 'shells/textfield/textfield';

type QuillOnChange = (value: string) => void;

type OwnProps = FieldProps & {
    isMultiSequence: boolean;
    isDisabled: boolean;
    onSubjectChange?: (arg1: string) => void;
    autoFocus: boolean;
};

type Props = FieldProps & OwnProps;

type State = {
    value: string;
};

export class SubjectField extends React.Component<Props, State> {
    handleChangeDebounced: QuillOnChange;

    constructor(props: Props) {
        super(props);
        this.handleChangeDebounced = _.debounce((value) => {
            props.onSubjectChange?.(value);
        }, 200);
    }

    render() {
        return (
            <TextField
                onFocus={(e: any) => {
                    this.props.input.onFocus(e);
                }}
                // @ts-expect-error
                onBlur={this.props.input.onBlur}
                // Note that changes may trigger changes in other subjects.
                // That happens in our redux-form reducer plugin (emailComposerFormReducerPlugin).
                onChange={this.handleChange}
                value={this.props.input.value}
                errorMessage={
                    this.props.meta.submitFailed && !this.props.isMultiSequence
                        ? this.props.meta.error
                        : undefined
                }
                autoFocus={this.props.autoFocus}
                disabled={this.props.isDisabled}
                placeholder='Subject'
            />
        );
    }

    handleChange = (value: string) => {
        this.props.input.onChange(value);
        this.handleChangeDebounced(value);
    };
}
